<template>
  <Modal>
    <h2 slot="header" class="modal-title">
      {{$t('saveQuery.name')}}
    </h2>
    <div slot="body">
      <label for="title">{{$t('saveQuery.title')}}</label>
      <input v-model="search.title" id="title">
    </div>
    <div slot="footer">
      <button type="button" class="button" @click="closeSaveQueryModal()"> {{$t('saveQuery.cancel')}} </button>
      <button type="button" class="button" @click="saveNewQuery()"> {{$t('saveQuery.save')}} </button>
    </div>
  </Modal>
</template>

<script>
  import Modal from './Modal'
  import axios from 'axios'

  export default {
    name: 'SaveQuery',
    components: {Modal},
    props: {
      isSaveQueryModalVisible: Boolean, 
      search: Object
    },
    created () {
      this.originalQueryName = this.search.title
      //this.queryName = this.search.title
      //this.queryId = this.search.id
      //this.query = this.search.query
    },
    computed: {
    },
    data() {
      return {
        isVisible: false, 
        originalQueryName: ""
      }
    },
    updated() {
    },
    methods: {
      closeSaveQueryModal(){
        this.search.title = this.originalQueryName
        this.$emit('closeModal')
      },
      saveNewQuery() {
        let queryToSave = {
          name: this.search.title,
          query: this.search.query,
          id: this.search.id
        }
        axios.post(this.$store.state.user.url + '/queries', queryToSave, {headers: {'request_uuid': this.last_request,
        'Authorization': 'Bearer ' + this.$store.state.user.token
        }})
        .then((response) => { })
        this.$emit('closeModal')
      }
    },
    watch : {
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/save_query.sass"
</style>
